import { render } from "./BillingCard.vue?vue&type=template&id=176f7488"
import script from "./BillingCard.vue?vue&type=script&lang=js"
export * from "./BillingCard.vue?vue&type=script&lang=js"

import exportComponent from "/home/jenkins/workspace/Deploy unapatitafeliz backend PROD/admin-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__